import { CSSProperties } from 'react';
import { COPILOT_COLORS, COPILOT_LAYOUT } from 'globalStyles';

const { WPP } = COPILOT_COLORS;
const { SPACING } = COPILOT_LAYOUT;

export const bulkCreatePixelPickerStyles: { [key: string]: CSSProperties } = {
  subHeaderMessage: {
    boxShadow: 'none',
    backgroundColor: WPP.grey300,
    borderRadius: '8px',
    marginBottom: SPACING[12],
    marginTop: SPACING[12],
  },
  unavailablePixel: {
    fontWeight: 'normal',
    color: WPP.grey500,
  },
};
